module.exports = __webpack_public_path__ + "img/fachai.923c0e9d.png";